import { render } from "./PagePagination.vue?vue&type=template&id=a76c54ee&scoped=true"
import script from "./PagePagination.vue?vue&type=script&lang=js"
export * from "./PagePagination.vue?vue&type=script&lang=js"

import "./PagePagination.vue?vue&type=style&index=0&id=a76c54ee&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a76c54ee"]])

export default __exports__